import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  ListSitemapPagesOptions,
  ListSitemapPagesResponse,
  listSitemapPages as universalListSitemapPages,
} from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/seo' };

export function listSitemapPages(
  httpClient: HttpClient
): ListSitemapPagesSignature {
  return (options?: ListSitemapPagesOptions) =>
    universalListSitemapPages(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListSitemapPagesSignature {
  /**
   * Lists sitemap pages for a given item type with optional pagination.
   * `item_type` only covers dynamic, repeater-generated items (Stores products, Blog posts,
   * Bookings services, etc. - see ItemType). It does NOT cover a site's static/main pages
   * (e.g. classic Editor "Home", "About", "Contact" pages) - those aren't represented by any
   * ItemType value and are never returned here, even for a fully published site. An empty or
   * partial `pages` result for a given itemType is not a signal that the site's static pages
   * are missing or unpublished.
   * This method is intended for headless sites, which fetch these entries to build and serve
   * their own sitemap.xml. Classic Editor/Studio sites don't need it - Wix generates and serves
   * their sitemap.xml for them. Note that the method does not detect or reject a site's editor
   * type; it reads the site's live Site Structure either way. So it is not a way to distinguish
   * headless from classic sites, and it is not the right tool for diagnosing a classic site's
   * auto-generated sitemap - inspect the sitemap XML served on that site's own domain instead.
   *
   * Returns NOT_FOUND when the site is not indexable or is not published.
   * @returns Response message for getting sitemap pages
   */
  (options?: ListSitemapPagesOptions): Promise<
    NonNullablePaths<
      ListSitemapPagesResponse,
      | `pages`
      | `pages.${number}._id`
      | `pages.${number}.shouldBeIncludedInSitemap`
      | `pages.${number}._updatedDate`,
      4
    >
  >;
}

export {
  CursorPaging,
  Cursors,
  Image,
  ItemType,
  ListSitemapPagesOptions,
  ListSitemapPagesRequest,
  ListSitemapPagesResponse,
  ListStaticSitemapPagesRequest,
  ListStaticSitemapPagesResponse,
  PagingMetadataV2,
  SitemapEntry,
  Video,
} from './promote-seo-v1-headless-sitemap-entry-seo-sitemap-entries.universal.js';
